import {
  ADDUPDATENOTIFICATIONCONFIGADMIN_SUCCESS,
  ADDUPDATENOTIFICATIONCONFIGADMIN_FAILED,
  RESET_ADDUPDATENOTIFICATIONCONFIGADMIN,
  LOADING_ADDUPDATENOTIFICATIONCONFIGADMIN,
  NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGADMIN,
} from "../types/index";

import { adminServices } from "../../config/axios";

const resetAddUpdateNotificationConfigAdmin = () => {
  return { type: RESET_ADDUPDATENOTIFICATIONCONFIGADMIN };
};

const addUpdateNotificationConfigAdminLists =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDUPDATENOTIFICATIONCONFIGADMIN });
    await adminServices
      .post("addUpdateNotifConfigAdmin", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(adminAddUpdateNotificationConfigsuccess(res.data));
            break;
          default:
            dispatch(adminAddUpdateNotificationConfigFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGADMIN,
          payload: err,
        });
      });
  };

function adminAddUpdateNotificationConfigsuccess(data) {
  return {
    type: ADDUPDATENOTIFICATIONCONFIGADMIN_SUCCESS,
    payload: data,
  };
}

function adminAddUpdateNotificationConfigFailed(data) {
  return {
    type: ADDUPDATENOTIFICATIONCONFIGADMIN_FAILED,
    payload: data,
  };
}

export {
  resetAddUpdateNotificationConfigAdmin,
  addUpdateNotificationConfigAdminLists,
};
